import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./add_state.css"; //
import { AddStateMobileStep2 } from "./add_state_mobile";
export default function AddStateStep2() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // استقبال البيانات الممررة من الخطوة الأولى
  const formData = location.state || {};

  // حالة السجل الطبي للمريض
  const [medicalRecord, setMedicalRecord] = useState({
    blood_type: "",
    chronic_diseases: "",
    allergies: "",
    surgical_history: "",
    vaccines: ""
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // تحديث حالة الخيارات عند الاختيار أو الكتابة
  const handleChange = (e) => {
    const { name, value } = e.target;
    setMedicalRecord(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleNext = () => {
    navigate("/add-state-step3", {
      state: {
        ...formData,
        ...medicalRecord
      },
    });
  };

  const handleBack = () => {
    navigate("/add-state", { state: formData });
  };

  if (isMobile) {
    return (
      <AddStateMobileStep2 
          medicalRecord={medicalRecord}
          handleChange={handleChange}
          onNext={handleNext}
          onBack={handleBack}
      />
    );
  }

  return (
    <div className="add-state-container" dir="rtl">
      {/* الشعار الوطني والترويسة العلوية الثابتة */}
      <img className='syria-logo-add-state-logo' src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="Syria Logo" />
      <div className="add-state-title">إضافة حالة</div>
      
      {/* مؤشر شريط التقدم للخطوة الثانية */}
      <div className="add-state-stepper2">
        <div className="add-state2" onClick={handleBack}>1</div>
        <div className="add-state-stepper-line"></div>
        <div className="add-state2 as-step-active">2</div>
        <div className="add-state-stepper-line"></div>
        <div className="add-state2">3</div>
      </div>

      <div className="add-state-form">
        {/* عنوان المكون الفرعي "السجل الطبي" */}
        <div className="add-state-title-form" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '25px' }}>
            <h2>السجل الطبي</h2>
        </div>

        {/* تموضع الحقول على شكل شبكة (Grid) */}
        <div className="add-state-grid">
          
          <div className="add-state-grid-item">
            <label>زمرة الدم</label>
            <input 
              list="blood_types" 
              name="blood_type" 
              className="add-state-input" 
              placeholder="اختر أو اكتب الزمرة" 
              value={medicalRecord.blood_type} 
              onChange={handleChange} 
            />
            <datalist id="blood_types">
              <option value="A+" />
              <option value="A-" />
              <option value="B+" />
              <option value="B-" />
              <option value="AB+" />
              <option value="AB-" />
              <option value="O+" />
              <option value="O-" />
            </datalist>
          </div>

          <div className="add-state-grid-item">
            <label>الأمراض المزمنة</label>
            <input 
              list="chronic_list" 
              name="chronic_diseases" 
              className="add-state-input" 
              placeholder="اختر المرض أو اكتبه" 
              value={medicalRecord.chronic_diseases} 
              onChange={handleChange} 
            />
            <datalist id="chronic_list">
              <option value="لا يوجد" />
              <option value="السكري" />
              <option value="ارتفاع ضغط الدم" />
              <option value="الربو" />
              <option value="أمراض القلب" />
            </datalist>
          </div>

          <div className="add-state-grid-item">
            <label>الحساسية</label>
            <input 
              list="allergies_list" 
              name="allergies" 
              className="add-state-input" 
              placeholder="اختر نوع الحساسية أو اكتبه" 
              value={medicalRecord.allergies} 
              onChange={handleChange} 
            />
            <datalist id="allergies_list">
              <option value="لا يوجد" />
              <option value="بنسلين" />
              <option value="حساسية غذائية" />
              <option value="أتربة وغبار" />
            </datalist>
          </div>

          <div className="add-state-grid-item">
            <label>العمليات الجراحية السابقة</label>
            <input 
              list="surgical_list" 
              name="surgical_history" 
              className="add-state-input" 
              placeholder="اختر الجراحة أو اكتبها" 
              value={medicalRecord.surgical_history} 
              onChange={handleChange} 
            />
            <datalist id="surgical_list">
              <option value="لا يوجد" />
              <option value="جراحة قلب" />
              <option value="جراحة بطن واستئصال" />
              <option value="جراحة عظام" />
            </datalist>
          </div>

          <div className="add-state-grid-item" style={{ gridColumn: "span 2" }}>
            <label>اللقاحات المستلمة</label>
            <input 
              list="vaccines_list" 
              name="vaccines" 
              className="add-state-input" 
              style={{ width: "90%" }} 
              placeholder="اختر حالة اللقاح أو اكتب تفاصيل" 
              value={medicalRecord.vaccines} 
              onChange={handleChange} 
            />
            <datalist id="vaccines_list">
              <option value="مكتمل التحصين" />
              <option value="جزئي" />
              <option value="لم يتلقى أي لقاح" />
            </datalist>
          </div>

        </div>

        {/* أزرار التحكم بالتنقل */}
        <div className="add-state-actions" style={{ gap: '20px' }}>
           <button type="button" className="add-state-btn-primary" style={{ backgroundColor: '#6c757d' }} onClick={handleBack}> السابق </button>
           <button type="button" className="add-state-btn-primary" onClick={handleNext}> التالي </button>
        </div>
      </div>
    </div>
  );
}